// extracted by mini-css-extract-plugin
export default {"logo":"LoaderSimplepass_logo__Fx-Cn","expandirYGirar":"LoaderSimplepass_expandirYGirar__L+ps+"};